"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shouldVideoLimitBannerRender = exports.getHubLVideoHubLTag = exports.getHubLParamsForVideoPlayer = exports.getIsConversionAssetValid = exports.isHubLVideo = exports.getHubLVideoPlayerIdFromFile = exports.getHubLVideoParamObjectFromFile = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _Constants = require("FileManagerLib/Constants");

var hubLVideoUtils = _interopRequireWildcard(require("FileManagerCore/utils/hubLVideo"));

var _String = require("FileManagerLib/utils/String");

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

var CONVERSION_ASSET_NECESSARY_PROPERTIES = ['type', 'id', 'position'];

var getHubLVideoParamObjectFromFile = function getHubLVideoParamObjectFromFile(file) {
  return hubLVideoUtils.getHubLVideoParamObjectFromFile(file);
};

exports.getHubLVideoParamObjectFromFile = getHubLVideoParamObjectFromFile;

var getHubLVideoPlayerIdFromFile = function getHubLVideoPlayerIdFromFile(file) {
  return hubLVideoUtils.getHubLVideoPlayerIdFromFile(file);
};

exports.getHubLVideoPlayerIdFromFile = getHubLVideoPlayerIdFromFile;

var isHubLVideo = function isHubLVideo(file) {
  return hubLVideoUtils.isHubLVideo(file);
};

exports.isHubLVideo = isHubLVideo;

var logBadConversionAssetData = function logBadConversionAssetData(failureMessage) {
  var error = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  _devLogger.default.warn({
    message: "[Video HubL Tag] " + failureMessage + ". HubL tag will ignore it. " + error
  });
};

var getDoesConversionAssetHaveNecessaryProperties = function getDoesConversionAssetHaveNecessaryProperties(conversionAsset) {
  return CONVERSION_ASSET_NECESSARY_PROPERTIES.every(function (property) {
    return conversionAsset[property] !== null && conversionAsset[property] !== undefined;
  });
};

var getIsConversionAssetValid = function getIsConversionAssetValid(conversionAsset) {
  if (!((0, _typeof2.default)(conversionAsset) === 'object' && conversionAsset !== null)) {
    logBadConversionAssetData('conversion_asset attribute needs to be a valid JSON object', "conversion_asset is " + (conversionAsset === null ? 'null' : 'not an object'));
    return false;
  } else if (!getDoesConversionAssetHaveNecessaryProperties(conversionAsset)) {
    logBadConversionAssetData("conversion_asset must have at least 3 properties: " + CONVERSION_ASSET_NECESSARY_PROPERTIES.join());
    return false;
  }

  return true;
};

exports.getIsConversionAssetValid = getIsConversionAssetValid;

var getHubLParamsForVideoPlayer = function getHubLParamsForVideoPlayer(params) {
  var hubLVideoPlayerParams = (0, _extends2.default)({}, _Constants.DefaultHubLVideoParams, params);
  return Object.keys(hubLVideoPlayerParams).filter(function (key) {
    return _Constants.SupportedHubLVideoParams.includes(key);
  }).filter(function (key) {
    return key !== 'conversion_asset' || getIsConversionAssetValid(hubLVideoPlayerParams[key]);
  }).map(function (key) {
    var val = hubLVideoPlayerParams[key];

    if (typeof val === 'boolean') {
      return key + "=" + (0, _String.capitalizeString)(val.toString());
    } else if (key === 'conversion_asset') {
      try {
        return "conversion_asset='" + JSON.stringify(val) + "'";
      } catch (error) {
        logBadConversionAssetData(error);
      }
    }

    return key + "='" + val + "'";
  }).join(', ');
};

exports.getHubLParamsForVideoPlayer = getHubLParamsForVideoPlayer;

var getHubLVideoHubLTag = function getHubLVideoHubLTag(params) {
  return "{% video_player \"embed_player\" " + getHubLParamsForVideoPlayer(params) + " %}";
};

exports.getHubLVideoHubLTag = getHubLVideoHubLTag;

var shouldVideoLimitBannerRender = function shouldVideoLimitBannerRender(params) {
  var hasUserExceededVideoLimit = params.hasUserExceededVideoLimit,
      type = params.type,
      isVideoLimitBannerDismissed = params.isVideoLimitBannerDismissed;
  return type === _Constants.DrawerTypes.HUBL_VIDEO && !isVideoLimitBannerDismissed && hasUserExceededVideoLimit;
};

exports.shouldVideoLimitBannerRender = shouldVideoLimitBannerRender;